import { acme } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';

export function archiveSearch({ url: { integration }, token }: IAPI) {
  return (req: acme.ArchiveSearchReq): Promise<acme.ArchiveSearchRes> =>
    send({
      baseURL: integration ?? '',
      token,
      path: '/acme/v1/archive-search',
      method: 'GET',
      searchParams: req,
    });
}
